<div class='footer'>
     <div class="container">
      <div class="row" style="text-align:center; display:inline;">
        &copy;
        Michaela Chan {{current_year}}
       </div>
   </div>
</div>
